// A business's Google reviews link (0090; Liam, 26 Oct 2026): https, a Google address that opens its listing or its review
// box, no sign-in parts in it. The server's copy is functions/lib/reviews-link.ts; the two give the same answer.
const HOSTS = ['maps.app.goo.gl', 'g.page', 'goo.gl', 'g.co', 'www.google.com', 'google.com', 'www.google.co.uk', 'google.co.uk', 'maps.google.com', 'maps.google.co.uk', 'search.google.com']

export function reviewsLinkProblem(text: string): string | null {
  let u: URL
  try { u = new URL(text) } catch { return 'Paste the whole link, starting https://' }
  if (u.protocol !== 'https:') return 'The link should start https://'
  if (u.username || u.password) return "That link can't be used."
  const host = u.hostname.toLowerCase()
  if (!HOSTS.includes(host)) return "That doesn't look like a Google link. Copy it from your Google Business Profile or Google Maps."
  if ((host === 'goo.gl' && !u.pathname.startsWith('/maps')) || ((host.endsWith('google.com') || host.endsWith('google.co.uk')) && host !== 'search.google.com' && !u.pathname.startsWith('/maps') && !u.pathname.startsWith('/search'))) return "That doesn't look like a Google Maps or reviews link."
  if (text.length > 300) return 'That link is too long.'
  return null
}
